import React, { useEffect, useState } from "react";
import { Row, Col, Container, Card, CardTitle, CardBody } from "reactstrap";
import PaymentList from "./PaymentList";
import PaymentDetails from "./PaymentDetails";
import Service from "../../../../services";
import { catchError } from "../../../../utils/Utils";
import { AxiosError } from "axios";

export interface PriceLayoutProps {
    type: string;
}

const PricingLayout: React.FC<PriceLayoutProps> = (props: any, ref: any) => {
  const service = new Service();
  const [paymentList, setPaymentList] = useState<any>([]);
  const [paymentDetails, setPaymentDetails] = useState<any>({});
  const [loading, setLoading] = useState<Boolean>(false);
  const _paymentDetails:any = {
    id: "test",
    name: "ACH Service Options",
    options: [
      {
        name: "Sample Feed Name",
        frequence: "Per Item",
        format: "Percent (%)",
        isActive: false,
        id: 789,
      },
      {
        name: "Sample Feed Name",
        frequence: "Per Item",
        format: "Percent (%)",
        isActive: false,
        id: 7891,
      },
      {
        name: "Sample Feed Name",
        frequence: "Per Item",
        format: "Percent (%)",
        isActive: false,
        id: 7892,
      },
    ],
  };

  const getPaymentList = () => {
    // service
    // .getPaymentList()
    // .then((r: any) => {

    // })
    // .catch((error: AxiosError) => {
    //   catchError(error, true);
    // })
    // .finally(() => {
    //     setLoading(false);
    // })

    const sampleData = [
      {
        category: "Standard Pricing Options",
        items: [
          {
            name: "Pass-through Plus Pricing",
            id: "1",
            isActive: true
          },
          {
            name: "Flat Pricing",
            id: "2",
            isActive: false,
          },
          {
            name: "Tiered Pricing",
            id: "3",
            isActive: true,
          },
          {
            name: "Dual Pricing",
            id: "4",
            isActive: false,
          },
        ],
      },

      {
        category: "Customized Pricing Options",
        items: [
          {
            name: "Additional Options",
            id: "1",
            isActive: false,
          },
          {
            name: "PIN Debit",
            id: "2",
            isActive: false,
          },
          {
            name: "ACH Service",
            id: "3",
            isActive: false,
          },
          {
            name: "Gateway",
            id: "4",
            isActive: false,
          },
          {
            name: "Equipment & Terminals",
            id: "5",
            isActive: false,
          },
          {
            name: "Giftcard, Loyalty, Closed Loop",
            id: "6",
            isActive: false,
          },
        ],
      },
    ];
    if(props.type==='standard'){
        setPaymentList(sampleData.filter((list:any)=>list.category ==='Standard Pricing Options'));
    } else {
        setPaymentList(sampleData.filter((list:any)=>list.category ==='Customized Pricing Options'));
    }
  };

  const getPaymentDetails = (id:any) => {
    // service
    // .getPaymentDetails(id)
    // .then((r: any) => {

    // })
    // .catch((error: AxiosError) => {
    //   catchError(error, true);
    // })
    // .finally(() => {
    //     setLoading(false);
    // })
    const _items = paymentList[0]?.items?.map((p:any)=>{if(p.id===id){p.clicked= true;} else {p.clicked= false;} return p;});
    paymentList.items =_items;
    setPaymentList(paymentList);
    setPaymentDetails(_paymentDetails);
  };
  useEffect(() => {
    getPaymentList();
  }, []);

  return (
    <Container>
      <Row>
        <Col xs="4">
           <div className="container-header">Payments | Lut</div>

          <PaymentList paymentList={paymentList} getPaymentDetails={getPaymentDetails} type={props.type}></PaymentList>
        </Col>
        <Col xs="8">
          <PaymentDetails paymentDetails={paymentDetails} type={props.type}></PaymentDetails>
        </Col>
      </Row>
    </Container>
  );
};

export default PricingLayout;
